var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "testimonial_container" }, [
    _c("div", {
      staticClass: "testimonial",
      domProps: { innerHTML: _vm._s(_vm.testimonial.testimonial) }
    }),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "username" }, [
      _vm._v(_vm._s(_vm.testimonial.username))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "entity" }, [
      _vm._v(_vm._s(_vm.testimonial.entity))
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "see-more-link",
        attrs: {
          href: "/" + _vm.$t("rewriting.passenger-feedback-url") + ".html"
        }
      },
      [_vm._v(_vm._s(_vm.$t("home.see-more-testimonials")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c290a2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c290a2c","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeTestimonials.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2c290a2c","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeTestimonials.vue
// module chunks = 1 2 3